'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import UICheckbox from 'UIComponents/input/UICheckbox';
import Small from 'UIComponents/elements/Small';
import { callIfPossible } from 'UIComponents/core/Functions';
import { EditableLegalConsentKeys } from 'FormsCommonComponents/constants/LegalConsent';
import LegalConsent, { getEditableLegalConsentKeysForLegalConsentType } from 'FormsCommonComponents/lib/LegalConsent';
import isEmpty from 'hs-lodash/isEmpty';
import * as HtmlSanitizer from 'sanitize-text/sanitizers/HtmlSanitizer';
export default class LegalConsentFields extends Component {
  constructor() {
    super();
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleCheckboxChange(checkbox, checked, isCommunicationConsent) {
    const {
      onCommunicationCheckboxChange
    } = this.props;

    if (!isCommunicationConsent) {
      return;
    }

    callIfPossible(onCommunicationCheckboxChange, checkbox, checked);
  }

  renderHelpText(helpText) {
    if (!helpText) {
      return null;
    }

    return /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: HtmlSanitizer.formatHtml(helpText)
        }
      })
    });
  }

  renderCheckbox(name, label, helpText, isCommunicationConsent = false, checkbox = {}) {
    const {
      communicationConsentCheckedState
    } = this.props;
    let isChecked = false;

    if (isCommunicationConsent) {
      const currentCheckbox = (communicationConsentCheckedState || []).find(item => item.communicationTypeId === checkbox.communicationTypeId);

      if (!isEmpty(currentCheckbox)) {
        isChecked = currentCheckbox.consented;
      }
    }

    const requiredStyle = {
      color: 'red',
      'padding-left': '4px'
    };
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(UICheckbox, {
        type: "checkbox",
        name: name,
        size: "small",
        defaultChecked: isChecked,
        onChange: ({
          target: {
            checked
          }
        }) => this.handleCheckboxChange(checkbox, checked, isCommunicationConsent),
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            display: 'flex'
          },
          children: [/*#__PURE__*/_jsx("span", {
            dangerouslySetInnerHTML: {
              __html: HtmlSanitizer.formatHtml(label)
            }
          }), checkbox.required ? /*#__PURE__*/_jsx("span", {
            style: requiredStyle,
            children: "*"
          }) : null]
        }), this.renderHelpText(helpText)]
      })
    }, name);
  }

  renderText(name, text) {
    return /*#__PURE__*/_jsx("p", {
      dangerouslySetInnerHTML: {
        __html: HtmlSanitizer.formatHtml(text)
      }
    }, name);
  }

  render() {
    const {
      legalConsentRecord
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "legal-consent-container",
      children: Object.values(getEditableLegalConsentKeysForLegalConsentType(legalConsentRecord.getLegalConsentType()) || {}).map(key => {
        switch (key) {
          case EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT:
          case EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT:
          case EditableLegalConsentKeys.PRIVACY_POLICY_TEXT:
            return this.renderText(key, legalConsentRecord.get(key));

          case EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES:
            return legalConsentRecord.get(key).map(checkbox => {
              return this.renderCheckbox(`LEGAL_CONSENT.subscription_type_${checkbox.communicationTypeId}`, checkbox.label, null, true, checkbox);
            });

          case EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL:
            return this.renderCheckbox(key, legalConsentRecord.get(key), legalConsentRecord.get(EditableLegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT), false, {
              required: true
            });

          default:
            return null;
        }
      })
    });
  }

}
LegalConsentFields.propTypes = {
  legalConsentRecord: PropTypes.instanceOf(LegalConsent).isRequired,
  communicationConsentCheckedState: PropTypes.array,
  onCommunicationCheckboxChange: PropTypes.func
};